<template>
	<div>
		<OverviewTitleBox :title="'LPG'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">LPG</H6>
		</div>
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCardComp icon="fa-chart-line" prefix="SALES TOTAL" unit="B" :data="ytd.sales.rekap[0]" infocol="Info" valuecol="Value" :url="'/lpg/report?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=&pso=bypso'"/> <!--  url="/lpg" -->
				<InfoCardComp icon="fa-money-bill-alt" prefix="SALES PSO" unit="B" :data="ytd.sales.pso[0]" infocol="Info" valuecol="Value" :url="'/lpg/report?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=&pso=PSO&detail1=area'"/>
				<InfoCardComp icon="fa-coins" prefix="SALES NON PSO" unit="B" :data="ytd.sales.nonpso[0]" infocol="Info" valuecol="Value" :url="'/lpg/report?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd') + '&period=yearly&area=&pso=NONPSO&detail1=area'"/>
			</div>
			<div class="col-md-4">
				<InfoCardComp icon="fa-store-alt" prefix="KEAGENAN LPG" unit="" :data="keagenan.progress" infocol="Info" valuecol="Value" :url="'/lpg/keagenan?status=1'" /> <!-- url="/lpg/keagenan" -->
			</div>
		</div>
	</div>
</template>

<script>
import LPG from '@/components/page/LPG.js'
import InfoCardComp from '@/views/pages/InfoCardComp.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'

export default{
	extends: LPG,
	components:{
		InfoCardComp,
		OverviewTitleBox,
	},
    mounted(){
		this.loadYTD();
		this.loadKeagenan();
    },
    methods:{
	}
}

</script>